import { isEmpty } from "lodash";
import { INITIAL_STATE } from "../constants/AppConstants";
import { SET_CURRENT_USER } from "../constants/ActionTypes";

export default (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case SET_CURRENT_USER: {
      const isAuthenticated =
        !isEmpty(action.user) &&
        Boolean(localStorage.getItem("flask_url")) &&
        Boolean(localStorage.getItem("verified"));

      return {
        ...state,
        auth: {
          isAuthenticated,
          user: action.user
        }
      };
    }
    default:
      return state;
  }
};
